import {useSuspenseQuery} from '@github-ui/react-query'
import {reactFetch} from '@github-ui/verified-fetch'
import {usePageDataUrl} from '@github-ui/pull-request-page-data-tooling/use-page-data-url'
import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import type {DiffstatData} from '../payloads/header'
import {pullRequestsLayoutRoute} from '../../routes/layout-route'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {useIsDataRouterEnabled} from '@github-ui/react-core/future/use-is-data-router-enabled'

// Deprecated and removable once we remove when cleaning up PR non data router code.
export function useDiffstatData() {
  const diffStatsURL = usePageDataUrl(PageData.diffstat)

  return useSuspenseQuery<DiffstatData>({
    queryKey: [PageData.diffstat, diffStatsURL],
    queryFn: async () => {
      const result = await reactFetch(diffStatsURL)
      if (!result.ok) throw new Error(`HTTP ${result.status}`)
      const json = await result.json()
      return json
    },
    staleTime: Infinity,
  })
}

export function useDiffstatRouterData() {
  // We are disabling the rules of hooks here to default to useDiffstatData
  // for consumers of DiffComparisonViewer that are not wrapped in a DataRouter.
  const isDataRouter = useIsDataRouterEnabled()
  // eslint-disable-next-line react-hooks/rules-of-hooks
  if (!isDataRouter) return useDiffstatData().data?.diffstat

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const {data} = useRouteQuery(pullRequestsLayoutRoute, PageData.diffstat)
  return data?.diffstat
}
